export const UnexpectedError = new Error("Unexpected error received");
